export const isEmpty = (str: any) => {
    if (str !== "" && str !== "null" && str !== undefined && str !== null && str !== "undefined" && str !== "undefined (undefined)") {
        return str
    } else {
        return ""
    }
}